/**
 * The Aeven OnePlatform project logo, as defined by the wiki brand guide
 * (`Design/Branding/Aeven-Brand-Guide.md`, section "Project logo: Aeven
 * OnePlatform"). It names the platform; the plain `aeven` wordmark names the
 * company, which is why this is what the shell of a platform UI carries.
 *
 * The guide is explicit that the shipped files do not work on a sage or dark
 * surface, because the wordmark is near black, and that inverting them locally
 * is not allowed - a cream-on-dark variant has to be asked for. Our sidebar and
 * sign-in banner are both sage, so the logo is given its own cream plate
 * instead: a light surface for it to sit on, with no pixel of the asset
 * touched. That is also what keeps the two themes honest, since the dark
 * sidebar (`navDark`) is no better a background than the sage one.
 *
 * Both assets are cropped and downscaled from
 * `Design/Branding/assets/aeven-oneplatform-logo.png` (RGBA, 2000x2000): the
 * lockup trimmed to its own alpha bounds, and the tile mark on its own for the
 * collapsed rail, where the type would be unreadable at any size that fits.
 */
import { brand } from '../theme/palette';

/** Pale, the lightest colour in the specification, as the logo's own ground. */
export const LOGO_CREAM = brand.pale;

/** Intrinsic size of the trimmed lockup asset, kept here so both users agree. */
export const LOGO_ASPECT = 348 / 156;

/**
 * Padding as a fraction of the plate height.
 *
 * The guide asks for one tile width of clear space on every side. One tile is
 * two thirds of the mark, which inside a 224px sidebar rail would leave the
 * logo too small to read, so the plate carries a proportional margin instead.
 * A deliberate, documented deviation rather than an oversight.
 */
export const LOGO_PADDING = 0.16;
